import { Injectable } from "@angular/core";
import { Http, Headers, Response, Request, BaseRequestOptions, RequestMethod, ResponseContentType } from "@angular/http";
import { Observable } from "rxjs";
import { Router } from '@angular/router';
import { APPCONFIG } from '../config';
import { AuthHttp, JwtHelper } from 'angular2-jwt/angular2-jwt';
import 'rxjs/add/operator/map'

@Injectable()
export class HttpClientbase {
    jwtHelper: JwtHelper = new JwtHelper();
    constructor(private http: Http, private authHttp: AuthHttp, private _router: Router) { }

    get(url: string) {
        return this.checkToken().flatMap(() => {
            return this.request(url, RequestMethod.Get);
        });
    }

    getFile(url: string) {
        return this.checkToken().flatMap(() => {
            return this.request(url, RequestMethod.Get, null, ResponseContentType.Blob);
        });
    }


    post(url: string, body: any) {
        return this.checkToken().flatMap(() => {
            return this.request(url, RequestMethod.Post, body);
        });
    }

    put(url: string, body: any) {
        return this.checkToken().flatMap(() => {
            return this.request(url, RequestMethod.Put, body);
        });
    }

    delete(url: string, body: any) {
        return this.checkToken().flatMap(() => {
            return this.request(url, RequestMethod.Delete, body);
        });
    }

    private checkToken(): Observable<boolean> {
        var currentUser = JSON.parse(localStorage.getItem('currentUserCobranca'));
        if (!currentUser) {
            return Observable.of(true);
        }

        let expired = this.jwtHelper.isTokenExpired(currentUser.token);

        if (expired) {
            return Observable.create(observer => {
                console.log('Token expirado');
                let headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                
                let body = this.setBodyRefresh(currentUser.refresh_token);

                this.http.post(APPCONFIG.authSettings.authURL, body, {
                    headers: headers
                }).subscribe(response => {
                    console.log('Token renovado');
                    let token = response.json();
                    if (token.access_token) {
                        localStorage.setItem('currentUser', JSON.stringify({ username: currentUser.email, token: token.access_token, refresh_token: token.refresh_token, perfil: currentUser.perfil, nome: currentUser.nome }));
                        observer.next(response);
                        observer.complete()
                    }
                },
                    err => {
                        localStorage.removeItem('currentUser');
                        this._router.navigate(['/login']);
                    });
            });
        }
        else {
            return Observable.of(true);
        }
    }

    private setBodyRefresh(refresh_token): String {
        let urlSearchParams = new URLSearchParams();
        urlSearchParams.append('client_id', 'PortalCobrancaApi');
        urlSearchParams.append('client_secret', 'o457b1aa6eb86921af9ba9aba8ced103');
        urlSearchParams.append('refresh_token', refresh_token);
        urlSearchParams.append('grant_type', 'refresh_token');
        return urlSearchParams.toString();
    }

    private request(url: string, method: RequestMethod, body?: any, responseType: ResponseContentType = ResponseContentType.Json): Observable<Response> {

        let headers = new Headers();
        var currentUser = JSON.parse(localStorage.getItem('currentUserCobranca'));
        let token = currentUser && currentUser.token;

        this.createAuthorizationHeader(headers, token);

        let options = new BaseRequestOptions();
        options.headers = headers;
        options.url = url;
        options.method = method;

        if (body != null)
            options.body = body;

        options.responseType = responseType;
        options.withCredentials = true;

        let request = new Request(options);

        return this.http.request(request);
    }

    private createAuthorizationHeader(headers: Headers, token) {
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + token);
    }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/services/httpclientBase.ts